import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { isRejectedWithValue } from '@reduxjs/toolkit'
import { message } from 'antd';
import { kickOut } from './util';
const API_URL = '/wls/web/manager';
const transformResponse = (response)=>{
    if( response.code>=8000 && response.code<9000){
        kickOut(window.location.pathname)
        sessionStorage.setItem('isReload',true)
    }
    return {
        ...response,
        data: response.data || undefined
    }
}

/**
 * 接口报错处理
 */
let showErrorMessage = false
export const rtkQueryErrorLogger = (api) => (next) => (action) => {
    if (isRejectedWithValue(action) && !showErrorMessage) {
        showErrorMessage = true
        setTimeout(() => {
            showErrorMessage = false
        }, 3000);
      const { status } = action.payload;
      let msg =  localStorage.getItem('language') === 'zh'?'系统错误':'System error'
      if(status === "FETCH_ERROR" || status ===  "PARSING_ERROR"){
        msg =  localStorage.getItem('language') === 'zh'?'网络请求失败':'Network request failed'
      }
      message.error(msg)
    }
    return next(action)
}

export const GETApi = (builder, path) => {
    return builder.query({
        query: data => {
            const {joinPath='',...otherData} = data || {}
            return {
                method: 'GET',
                url: `${path}${joinPath}`,
                params: otherData
            }
        },
        transformResponse
    })
}
export const POSTApi = (builder, path) => {
    return builder.mutation({
        query: data => {
            const {joinPath='',...otherData} = data || {}
            return {
                method: 'POST',
                url: `${path}${joinPath}`,
                body: otherData
            }
            
        },
        transformResponse
    })
}
export const DELETEApi = (builder, path) => {
    return builder.mutation({
        query: data => {
            const {joinPath='',...otherData} = data || {}
            return {
                method: 'DELETE',
                url: `${path}${joinPath}`,
                params: otherData
            }
        },
        transformResponse
    })
}
export const request = ({ reducerPath, endpoints }) => createApi({
    reducerPath,
    baseQuery: fetchBaseQuery({
        baseUrl: API_URL,
        prepareHeaders: (headers, { getState }) => {
            // console.log(headers);
            // const token = getState().auth.token;
            // if (token) {
            //     headers.set('Authorization', `Bearer ${token}`);
            // }
            headers.set('Language', localStorage.getItem('language'));
            return headers;
        },
    }),
    endpoints: (builder) => endpoints(builder)
    
})
